<div
  *ngIf="visibilityString || site?.noise?.level || displayRoadConditions() || potentialHazards"
  class="listing-content-section"
>
  <h3>Isolation, Noise Level, & Road Conditions</h3>
  <div class="linsting-info-grid">
    <div *ngIf="visibilityString" class="feature-row">
      <div class="feature-name">
        <strong>Isolation:</strong>
      </div>
      <div class="feature-name">
        {{ visibilityString }}
      </div>
    </div>
    <div *ngIf="site?.noise?.level" class="feature-row">
      <div class="feature-name">
        <strong>Noise level:</strong>
      </div>
      <div class="feature-name">
        {{ site?.noise?.level | titlecase }}
        <span *ngIf="site?.noise?.description"> , {{ site?.noise?.description }} </span>
      </div>
    </div>
    <div *ngIf="displayRoadConditions()" class="road-condition-row">
      <div (click)="showRoadConditionDescription = !showRoadConditionDescription">
        <div class="feature-name">
          <strong>Road Conditions:</strong>
        </div>
        <div class="feature-name bold">
          {{ displayRoadConditions() }}
        </div>
        <div *ngIf="displayRoadConditionDescriptions() && !showRoadConditionDescription" class="dropdown-icon">
          <div class="html-embed expanded w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>

        <div *ngIf="displayRoadConditionDescriptions() && showRoadConditionDescription" class="dropdown-icon">
          <div class="w-embed">
            <curbnturf-misc-svg icon="dropdown"></curbnturf-misc-svg>
          </div>
        </div>
      </div>
      <div *ngIf="showRoadConditionDescription" class="fine-print offsite">
        {{ displayRoadConditionDescriptions() }}
      </div>
    </div>
  </div>
  <p *ngIf="potentialHazards" class="fine-print">
    <span class="semi-bold">Potential Hazards - </span>
    <span *ngIf="potentialHazardDescription" [innerHTML]="potentialHazardDescription"></span>
    <span *ngIf="potentialHazardDescription">
      The host has indicated there could be dangerous plants, animals, or land elements/features. Please contact host if
      you have any questions regarding any potential hazards.
    </span>
  </p>
  <curbnturf-contact-host [listing]="site?.listing"> </curbnturf-contact-host>
</div>
